import { create } from "zustand";
export const useUserSessionStore = create((set, get) => (
    {
        session: null,
        setSession: (sess) => set({ session: sess }),
    }
))